import Vue from 'vue'
import Router from 'vue-router'
import Start from '@/components/Start'
import Game from '@/components/Game'
import Loading from '@/components/Loading'
import Success from '@/components/Success'
import Language from '@/components/Language'

Vue.use(Router)  

export default new Router({
	routes: [
	{
		path: '/',
		name: 'start',
		component: Start
	}, {
		path: '/Game',
		name: 'game',
		component: Game
	}, {
		path: '/Loading',
		name: 'loading',
		component: Loading
	}, {
		path: '/Success',
		name: 'success',
		component: Success
	}, {
		path: '/Language',
		name: 'language',
		component: Language
	}
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js